import { Box, ButtonBase, styled } from '@mui/material';

export const StyledWeekDaySwitcher = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
}));

export const StyledWeekNavigation = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
}));

export const StyledWeekDays = styled(Box)(() => ({
	display: 'flex',
	justifyContent: 'space-between',
	gap: '2px',
	flex: 1,
}));

export const StyledWeekDayButton = styled(ButtonBase, {
	shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '2px',
	height: 'auto',
	borderRadius: '18px',
	padding: '10px 4px',
	minWidth: '33px',
	background: $selected ? '#C3DCFF' : 'transparent',
}));

export const StyledWeekDayLabel = styled('span', {
	shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
	fontSize: '12px',
	fontWeight: 400,
	color: $selected ? '#292929' : '#858585',
}));

export const StyledWeekDayCircle = styled(Box, {
	shouldForwardProp: (prop) => prop !== '$selected',
})<{ $selected: boolean }>(({ $selected }) => ({
	width: '24px',
	minHeight: '24px',
	borderRadius: '50%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border: `0.5px solid ${$selected ? '#fff' : '#C4C6C7'}`,
	color: $selected ? '#292929' : '#858585',
	backgroundColor: $selected ? '#fff' : 'transparent',
}));
